import axios, { AxiosError } from "axios";
import AuthClient from "./AuthClient";
import MyPartyResponse from "./responses/apiResponses";
import { ApiResponse, handleAxiosError } from "./responses/AxiosResponseHandler";

class PromoterGroupsApi {
  private authClient: AuthClient;

  constructor(authClient: AuthClient) {
    this.authClient = authClient;
  }

  public async getPromoterGroup(groupId: string): Promise<ApiResponse<MyPartyResponse> | undefined> {
    try {
      const authenticationResponse = this.authClient.getAuthenticationResponse();

      const response = await axios.get(
        `${this.authClient.getApiRoot()}/promoter/groups/${groupId}`,
        {
          headers: {
            Authorization: `Bearer ${authenticationResponse?.token}`,
          },
        }
      );

      return {
        statusCode: response.status,
        errorMessage: "",
        data: response.data as MyPartyResponse,
      };
    } catch (error) {
      const errorResponse = handleAxiosError<MyPartyResponse>(error as AxiosError);
      return {
        statusCode: errorResponse.statusCode,
        errorMessage: errorResponse.errorMessage,
        data: errorResponse.data,
      };
    }
  }
}

export default PromoterGroupsApi;
